import styled from 'styled-components';
import { decimalToKr } from '../../functions';
import { vatBreakdown } from '../../functions/vatBreakdown';
import { Line, RowView, Text } from '../../helpers';
import { useGlobalState } from '../../state';
import RoundBox from '../RoundBox/RoundBox';
import { useTranslation } from 'react-i18next';

type CustomerDetailsProps = {
    status?: string;
};

type WrapperProps = {
    status?: string;
};

const Wrapper = styled.div<WrapperProps>`
    margin-top: ${(props) => (props.status === 'failed' ? '3vh' : '8vh')};
`;

const EndCustomer = styled(Text)`
    /* margin-bottom: 1vh; */
`;

const LineList = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
`;

const CustomerDetails = ({ status }: CustomerDetailsProps) => {
    const [invoice] = useGlobalState('invoice');
    const { t } = useTranslation();

    const organization = invoice.organization;
    const lines = invoice.lines;

    const vatTotals = vatBreakdown(lines);
    return (
        <Wrapper status={status}>
            <RoundBox>
                <EndCustomer i={organization.name} fontWeight="bold" header />
                <RowView
                    style={{
                        flexDirection: 'column',
                        alignItems: 'flex-start'
                    }}>
                    <Text i={`${t('invoice_basis')} #${invoice.invoice_number}`} />
                    <Line />
                </RowView>
                <LineList>
                    {lines.map((item, index) => {
                        return (
                            <li key={index}>
                                <RowView style={{ gap: '10px' }}>
                                    <Text i={item.description} />
                                    <Text
                                        i={`${Number(item.amount_excl_vat).toLocaleString('sv-SE', {
                                            maximumFractionDigits: 2
                                        })} SEK`}
                                        style={{ textWrap: 'nowrap' }}
                                    />
                                </RowView>
                                <RowView style={{ gap: '5px' }}>
                                    <Text
                                        i={`
                                        ${t('vat')} ${item.vat_rate}%`}
                                    />
                                    <Text
                                        i={`${Number(item.vat_amount).toLocaleString('sv-SE', {
                                            maximumFractionDigits: 2
                                        })} SEK`}
                                        style={{ textWrap: 'nowrap' }}
                                    />
                                </RowView>
                            </li>
                        );
                    })}
                </LineList>
                {invoice.lines.length > 1 && <Line margin="10px 0 20px 0" />}
                {invoice.lines.length > 1 && (
                    <>
                        {vatTotals.map(({ rate, amount }) => {
                            return (
                                <RowView key={rate}>
                                    <Text i={`${t('vat')} ${rate}%`} />
                                    <Text
                                        i={`${amount.toLocaleString('sv-SE', {
                                            maximumFractionDigits: 2
                                        })} SEK`}
                                    />
                                </RowView>
                            );
                        })}
                        <RowView style={vatTotals.length > 0 ? { marginTop: 20 } : undefined}>
                            <Text i={t('ofWhichVAT')} />
                            <Text
                                i={`${Number(invoice.vat).toLocaleString('sv-SE', {
                                    maximumFractionDigits: 2
                                })} SEK`}
                                style={{ textWrap: 'nowrap' }}
                            />
                        </RowView>
                        <RowView>
                            <Text i={t('exclVAT')} />
                            <Text
                                i={`${Number(invoice.total_amount - invoice.vat).toLocaleString(
                                    'sv-SE',
                                    {
                                        maximumFractionDigits: 2
                                    }
                                )} SEK`}
                                style={{ textWrap: 'nowrap' }}
                            />
                        </RowView>
                    </>
                )}
                <Line />
                <RowView style={{ marginTop: '2vh' }}>
                    <Text i={t('toPay')} fontWeight="bold" />
                    <Text
                        i={`${Number(invoice.total_amount).toLocaleString('sv-SE', {
                            maximumFractionDigits: 2
                        })} SEK`}
                        fontWeight="bold"
                        style={{ textWrap: 'nowrap' }}
                    />
                </RowView>
            </RoundBox>
        </Wrapper>
    );
};

export default CustomerDetails;
